<template>
  <div>
    <!-- https://vite-pwa-org.netlify.app/frameworks/nuxt.html#pwa-assets -->
    <!-- <NuxtPwaManifest /> -->
    <NuxtLoadingIndicator :color="'#d3016a'" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup>
import formkitConfig from './formkit.config.js'

const { locale } = useI18n()
const route = useRoute()

watch(
  () => locale.value,
  // FormKit
  (formkitConfig.locale = locale.value),
  () => {
    lenis.value.scrollTo(0, { immediate: true })
  },
)

watch(
  () => route.query,
  () => {
    lenis.value.scrollTo(0)
  },
)

const { lenis } = useLenis()
provide('lenis', lenis)
</script>
